import { render, staticRenderFns } from "./edit-law.vue?vue&type=template&id=7f121fc5&"
import script from "./edit-law.vue?vue&type=script&lang=js&"
export * from "./edit-law.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports